<td class="value-cell">{{index}}</td>
<td class="value-cell" title="{{prThreadData.id}}">{{prThreadData.id}}</td>
<td class="value-cell" title="{{prThreadData.gridicsId}}">{{prThreadData.gridicsId}}</td>
<td class="value-cell" title="{{prThreadData.groupId}}">{{prThreadData.groupId}}</td>
<td class="value-cell" title="{{createStr}}">{{createStr}}</td>
<td class="value-cell" title="{{duration}}">{{duration}}</td>
